import {
    DropdownSort,
    Flex,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import { ChevronDown } from '@archipro-design/icons';
import FilterBarBoardPinSwitchButton from '~/modules/design-board/component/all-pins/FilterBarBoardPinSwitchButton';
import { useBoardFilterDropdown } from '~/modules/design-board/hook';
import * as S from './BoardListFilter.style';
import { useGetStartedAction } from '~/modules/design-board/hook/use-get-started-action';

const FilterBarForBoards = () => {
    const { css } = useStyles({ isAllPins: false });
    const { mobile } = useAppDisplayModeContext();

    const dropdownData = useBoardFilterDropdown();

    const { newBoardButton } = useGetStartedAction();

    return mobile ? (
        <div>mobile filter bar goes here</div>
    ) : (
        <Flex className={css(S.FilterBarButtons)} column={false}>
            <FilterBarBoardPinSwitchButton />

            <DropdownSort
                items={dropdownData.items}
                value={dropdownData.selectedItem}
                defaultValue={dropdownData.defaultItem}
                placeholder={dropdownData.placeholder}
                collapseIcon={<ChevronDown />}
                expandIcon={<ChevronDown className="expanded" />}
            />

            {newBoardButton}
        </Flex>
    );
};
export default FilterBarForBoards;
